import { render } from "./DeviceTabNotification.vue?vue&type=template&id=a5fa34aa"
import script from "./DeviceTabNotification.vue?vue&type=script&lang=js"
export * from "./DeviceTabNotification.vue?vue&type=script&lang=js"

import exportComponent from "/Users/linuxbasic/GitProjects/caru-platform-api/systems/caru-cloud-platform/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__